<template lang="html">

  <article class="evento-el">

    <div class="evento-wrapper column-between">

      <div class="top">
      <h3 class="tipo">{{data.categoria}}</h3>

      <div class="tips row-start">
        <h3 class="fecha">{{data.fechaInicio}}</h3>
        <h3 class="localizacion" v-if="data.lugar">{{data.lugar}}</h3>
      </div>

      <h2 class="titulo">{{data.titulo}}</h2>

      <p class="descripcion" v-html="data.descripcion"></p>

      <h3 class="tipo -apto" v-if="data.apto != null">{{(data.apto) ? 'Apto' : 'No apto'}}</h3>

    </div>

      <a v-if="data.necesitaSubirMemoria" class="btn -upload" @click="showmemoria = true">Subir memoria</a>

      <a v-if="!!data.inscripcionhabilitada & !data.inscrito" class="btn"
          @click="showinscripcion= true">Inscribirse</a>

    </div>

    <router-link :to="$t('enlaces.evento')+'/'+data.urlAcceso" class="enlace-cover">Ir al evento</router-link>


    <popup-memoria :id="data.urlAcceso" v-if="showmemoria" @close="showmemoria = false"></popup-memoria>

    <popup-inscripcion :id="data.urlAcceso" v-if="showinscripcion" @close="showinscripcion = false"></popup-inscripcion>

  </article>

</template>

<script lang="js">

  import popupInscripcion from '@/components/parts/popup-inscripcion-evento';

  import popupmemoria from '@/components/parts/popup-subir-memoria-evento';

  export default {
    name: 'evento-el',
    props : ['data'],
    data(){
      return{
        showmemoria : false,
        showinscripcion : false
      }
    },
    components : {
      'popup-inscripcion' : popupInscripcion,
      'popup-memoria' : popupmemoria
    }

  }
</script>

<style scoped lang="scss">
  .tipo.-apto{
    margin-top: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/parts/evento-el.vue